import { keyframes } from 'styled-components'

export const unfurl = keyframes`
	0% {
		transform: scale(0);
	}
	100% {
		transform: scale(1);
	}
`

export const fadeIn = keyframes`
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
`



// WEBPACK FOOTER //
// ./src/styles/keyframes.ts